import { MAX_NUM_OF_PLAYERS } from '@/helpers/constantsNew'

function getPlayerDetailSkeleton() {
  return {
    is_hero: false,
    range_content: null,
    group: null,
    group_id: null,
    groups_ids: null,
    hand: null,
    hands_ids: null,
  }
}

function initPlayersState() {
  return Array.from({ length: MAX_NUM_OF_PLAYERS }, () => getPlayerDetailSkeleton())
}

function getInitialState() {
  const res = {
    study_player: '0',
    study_table_mouseover: false,
    players_detail: initPlayersState(),
  }
  return res
}

const getters = {
  sol_detail_tableMouseover: state => state.study_table_mouseover,
  sol_detail_player: state => state.study_player,
  sol_detail_players: state => state.players_detail,
}

const actions = {
  sol_detail_initialize({ state, rootGetters }, { tableGroups }) {
    const hero = '0'
    const tableGroup = tableGroups.find(g => g.players?.[hero]?.range > 0)
    if (tableGroup) {
      Object.keys(state.players_detail).forEach(key => {
        state.players_detail[key].group_id = ''
        state.players_detail[key].group = null
        state.players_detail[key].hand = null
        state.players_detail[key].hands_ids = null
        state.players_detail[key].groups_ids = null
        state.players_detail[key].range_content = 'ev'
        state.players_detail[key].is_hero = false
      })
      state.study_player = hero
      state.players_detail[hero].is_hero = true
      state.players_detail[hero].group = tableGroup
      state.players_detail[hero].range_content = 'strategy'
      state.players_detail[hero].hand = tableGroup.combos.find(i => i.players?.[hero]?.range)
      state.players_detail[hero].hands_ids = tableGroup.combos.map(i => i.id)
    }
  },
  sol_detail_highlight({ state, rootGetters }, item = null) {
    if (item) {
      const players = item.players || item.category.players
      players?.forEach((itemPlayer, key) => {
        state.players_detail[key].groups_ids =
          itemPlayer?.groups || item.category.players[key]?.groups
      })
    } else {
      Object.keys(state.players_detail).forEach(key => {
        state.players_detail[key].groups_ids = null
      })
    }
  },
  sol_detail_hover_hand(
    { state, rootGetters, commit, dispatch, getters },
    { player = '0', hand, tableGroups, setPlayer = true } = {},
  ) {
    // check if any player has group_id
    const hasGroup = state.players_detail.some(i => i.group_id)

    if (hasGroup) return
    if (setPlayer) {
      state.study_player = player
    }

    if (!hand) {
      // reset group_ids for all players
      commit('sol_detail_set', {
        key: 'players_detail',
        playerProperty: 'groups_ids',
        value: null,
      })
      const group = state.players_detail[player].group
      if (group) {
        state.players_detail[player].hands_ids = group.combos.map(i => i.id)
      }
      return
    }
    state.players_detail[player].hand = hand
    state.players_detail[player].hands_ids = [hand.id]
    state.players_detail[player].group = tableGroups.find(group => group.id === hand.group_id)
    state.players_detail[player].groups_ids = [hand.group_id]
  },
  sol_detail_hover_chart({ state, dispatch, commit }, { hands, tableGroups } = {}) {
    commit('sol_detail_set', {
      key: 'players_detail',
      playerProperty: 'hands_ids',
      value: null,
    })
    hands.forEach((hand, index) => {
      dispatch('sol_detail_hover_hand', {
        hand,
        player: index.toString(),
        tableGroups,
        setPlayer: false,
      })
    })

    if (hands.every(hand => !hand)) {
      const playerDetail = state.players_detail[state.study_player]
      const group = tableGroups.find(g => g.id === playerDetail.group?.id)
      if (group) {
        commit('sol_detail_set', {
          player: state.study_player,
          key: 'players_detail',
          playerProperty: 'hands_ids',
          value: group.combos.map(c => c.id),
        })
      }
    }
  },
  sol_detail_click_hand({ state, dispatch }, { hand, tableGroups } = {}) {
    const hero = '0'
    if (state.players_detail[hero].group_id === hand.group_id) {
      state.players_detail[hero].group_id = ''
      dispatch('sol_detail_hover_hand', hand)
      return
    }
    state.study_player = hero
    state.players_detail[hero].hand = hand
    state.players_detail[hero].hands_ids = [hand.id]
    state.players_detail[hero].group_id = hand.group_id
    state.players_detail[hero].group = tableGroups.find(group => group.id === hand.group_id)
    state.players_detail[hero].groups_ids = null
  },
}

const mutations = {
  sol_detail_set(state, { key, value, player, playerProperty }) {
    // update players
    if (key === 'players_detail') {
      // If player specified, update that player
      if (player) {
        state[key][player][playerProperty] = value
      } else {
        // Otherwise update all players
        Object.keys(state[key]).forEach(p => {
          state[key][p][playerProperty] = value
        })
      }
    } else {
      state[key] = value
    }
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
